export default class LogServiceHelper {
  public static normalizeError(error: unknown): Error {
    if (error instanceof Error) {
      const normalizedError = error;
      if (error.message && typeof error.message === 'object') {
        normalizedError.message = JSON.stringify(error.message);
      }
      return normalizedError;
    } else {
      return new Error(typeof error === 'object' && error !== null ? JSON.stringify(error) : String(error));
    }
  }
}
